import { Route } from '@angular/router';
import { STATUS_CHECK_ROUTE } from '@rxap/ngx-status-check';

export const appRoutes: Route[] = [
  {
    path: 'error',
    loadChildren: () => import('angular-components/error/routes'),
  },
  {
    path: 'keycloak-login-redirect',
    loadComponent: () => import('./keycloak-login-redirect/keycloak-login-redirect.component'),
  },
  STATUS_CHECK_ROUTE,
  {
    path: '',
    loadChildren: () => import('./layout.routes'),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
